<template>
  <div class="fts-widget-title" :class="{'widget-title--preview': preview}">
    <fts-tippy
      append-content-class="d-widget-title-tippy-content"
      class="d-widget-title-wrapper"
      v-if="widgetName"
    >
      <fts-label-group
        slot="trigger"
        :item="{ name: widgetName }"
        append-label-class="d-widget-title-label"
      >
      </fts-label-group>
      <template #content>
        <div class="d-widget-title-badge">Custom</div>
        <fts-label-group
          :item="{ name: widgetName }"
        />
      </template>
    </fts-tippy>

    <fts-tippy
      append-content-class="d-widget-title-tippy-content"
      class="d-widget-title-wrapper"
      v-else-if="listingId"
    >
      <fts-label-group
        slot="trigger"
        :item-id="listingId"
        :list="moduleListing"
        emoji
        :emoji-size="20"
        append-label-class="d-widget-title-label"
        @click.native="!preview && $emit('click:listing')"
      >
      </fts-label-group>
      <template #content>
        <div class="d-widget-title-badge">Listing</div>
        <fts-label-group
          :item-id="listingId"
          :list="moduleListing"
          emoji
          :emoji-size="12"
        />
      </template>
    </fts-tippy>

    <fts-tippy
      append-content-class="d-widget-title-tippy-content"
      class="d-widget-title-wrapper"
      v-else
    >
      <fts-label-group
        slot="trigger"
        :item-id="moduleId"
        :list="modules"
        emoji
        :emoji-size="20"
        append-label-class="d-widget-title-label"
        @click.native="!preview && $emit('click:module')"
      >
      </fts-label-group>
      <template #content>
        <div class="d-widget-title-badge">Module</div>
        <fts-label-group
          :item-id="moduleId"
          :list="modules"
          emoji
          :emoji-size="12"
        />
      </template>
    </fts-tippy>

    <div class="d-widget-title-sub" v-if="widgetName || listingId">
      <fts-tippy
        append-content-class="d-widget-title-tippy-content"
        class="d-widget-title-wrapper"
      >
        <fts-label-group
          slot="trigger"
          :item-id="moduleId"
          :list="modules"
          emoji
          :emoji-size="14"
          append-label-class="d-widget-title-label"
          @click.native="!preview && $emit('click:module')"
        >
        </fts-label-group>
        <template #content>
          <div class="d-widget-title-badge">Module</div>
          <fts-label-group
            :item-id="moduleId"
            :list="modules"
            emoji
            :emoji-size="12"
          />
        </template>
      </fts-tippy>

      <fts-tippy
        append-content-class="d-widget-title-tippy-content"
        class="d-widget-title-wrapper"
        v-if="widgetName && listingId"
      >
        <fts-label-group
          slot="trigger"
          :item-id="listingId"
          :list="moduleListing"
          emoji
          :emoji-size="14"
          append-label-class="d-widget-title-label"
          @click.native="!preview && $emit('click:listing')"
        >
        </fts-label-group>
        <template #content>
          <div class="d-widget-title-badge">Listing</div>
          <fts-label-group
            :item-id="listingId"
            :list="moduleListing"
            emoji
            :emoji-size="12"
          />
        </template>
      </fts-tippy>
    </div>
  </div>
</template>

<script>
import FTSLabelGroup from '../elements/FTSLabelGroup';
import FTSTippy from '../elements/FTSTippy';

export default {
  components: {
    "fts-label-group": FTSLabelGroup,
    "fts-tippy": FTSTippy
  },
  props: {
    modules: Array,
    moduleId: [Number, String],
    listingId: [Number, String],
    widgetName: String,
    preview: Boolean
  },
  computed: {
    moduleListing() {
      const res = this.modules.find(x => x.id == this.moduleId);
      return res && res.menus;
    }
  }
}
</script>

<style lang="scss">
.fts-widget-title {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .d-widget-title-wrapper {
    max-width: 100%;
    cursor: pointer;
  }
  .d-widget-title-label {
    font-size: 1.25rem;
  }
  .d-widget-title-sub {
    max-width: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 0.125rem;
    .d-widget-title-wrapper {
      min-width: 0;
      max-width: 75%;
    }
    .d-widget-title-wrapper + .d-widget-title-wrapper {
      margin-left: 0.75rem;
    }
    .d-widget-title-label {
      font-size: 0.875rem;
    }
  }
  &.widget-title--preview {
    .d-widget-title-wrapper {
      cursor: default;
    }
  }
}
.d-widget-title-tippy-content {
  display: flex;
  align-items: center;
  .d-widget-title-badge {
    display: inline-flex;
    margin-right: 0.5rem;
    padding: 0.15rem 0.25rem;
    border-radius: 0.25rem;
    background-color: rgba(var(--fts-primary-rgb), 0.5);
    font-size: 0.75rem;
  }
  .fts-label-group .label-group__label {
    color: var(--fts-light);
  }
}
</style>